module.exports = __webpack_public_path__ + "17e49296d9351a5e2facc673e2a19f53.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/rocket-poster.png
// module id = 1606
// module chunks = 0